import { quoteForm } from "../_components/hubspot-formhandlers/_get-a-quote";
import { toggleCourseDetails } from "../_components/_toggle-course-details";

window.$ = jQuery;

$( document ).ready( function () {

	quoteForm();
	toggleCourseDetails();

} );